import style from "./listGdacs.module.scss";
import {warningAlert} from "../../util/assets";
import aqiIcon from "../../assets/aqi-icon.png";
import moment from "moment";
import {Scrollbars} from "react-custom-scrollbars-2";
import React, {useRef, useState} from "react";
import {connect} from "react-redux";
import {hideAlerts, showHideAlerts} from "../../action/alert";
import {colors, useOutsideAlerter} from "../../util/util";
import {setCurrentItem} from "../../action/page";
import {moderateFaceGray} from "../../util/assets";
import CloseIcon from '@mui/icons-material/Close';
import {getGdacs, getLogs} from "../../thunk/device";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import TsunamiIcon from '@mui/icons-material/Tsunami';
import FloodIcon from '@mui/icons-material/Flood';
import CycloneIcon from '@mui/icons-material/Cyclone';
import VolcanoIcon from '@mui/icons-material/Volcano';
import AirIcon from '@mui/icons-material/Air';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import Checkbox from "../UI/checkbox/checkbox";
import Button from "../UI/button/button";
import Input from "../UI/input/input";

function ListGdacs({ getGdacs, hideAlerts, setCurrentItem, data, getLogs}) {
    const alertRef = useRef(null);
    useOutsideAlerter(alertRef, hideAlerts);
    const [activeHeader, setActiveHeader] = useState("list");
    const [filterType, setFilterType] = useState(['EQ']);
    const [filterLevel, setFilterLevel] = useState(['red', 'orange']);
    const [filterDate, setFilterDate] = useState([moment().subtract(1, 'year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]);

    const [active, setActive] = useState(true);

    const handlerChangeStatus = (index) => {
        // let device = data.find(i => i._id === item.deviceId);
        // debugger;
        // setActiveMapData({index});
        setCurrentItem(data[index]?{...data[index], active: true}:{});
        // getLogs({id: item.deviceId});
        // device._id = "";
        // setCurrentItem(device?{...device, active: true}:{});
        // showHideAlerts(!alerts.active);
    };

    const handlerShowHeader = (header) => {
        setActiveHeader(activeHeader === header ? "" : header);
    };

    const handlerFilterType = (type) => {
        setFilterType(filterType.includes(type) ? filterType.filter(item => item !== type) : [...filterType, type]);
    };
    const handlerFilterLevel = (level) => {
        setFilterLevel(filterLevel.includes(level) ? filterLevel.filter(item => item !== level) : [...filterLevel, level]);
    };

    const handlerApplyFilter = () => {
        getGdacs({type: filterType, alertLevel: filterLevel, dateFrom: filterDate[0], dateTo: filterDate[1]});
    };
    const handlerFilterDate = (date, index) => {
        setFilterDate(prev => {
            const newDate = [...prev];
            newDate[index] = date;
            return newDate;
        });
    };
    return (
        <div className={[style.alertsRow, active ? style.active : ""].join(" ")}>
            {/* <div className={style.activeButton} onClick={() => setActive(!active)}>{active ? <CloseIcon /> : <ArrowBackIosNewIcon />}</div> */}
            <div className={[style.alertRow].join(" ")} ref={alertRef}>
                <div className={style.headerRow}>
                    <div
                        className={style.header}
                        onClick={() => handlerShowHeader("list")}
                    >
                        {/* <img src={warningAlert} alt=""/> */}
                        <span>List GDACS</span>
                    </div>
                </div>
                

                <div className={[style.alertList, activeHeader === "list" ? style.active : ""].join(" ")}>
                    <Scrollbars style={{height: "250px"}}>
                        {data.map((item, index) =>
                            (
                                <div
                                    className={style.alertItem}
                                    key={`alert_${index}`}
                                    onClick={() => handlerChangeStatus(index)}
                                >
                                    {item.type === "EQ" && <MonitorHeartIcon className={style.alertIcon}/> || ""}
                                    {item.type === "TS" && <TsunamiIcon className={style.alertIcon}/> || ""}
                                    {item.type === "FL" && <FloodIcon className={style.alertIcon}/> || ""}
                                    {item.type === "TC" && <CycloneIcon className={style.alertIcon}/> || ""}
                                    {item.type === "VO" && <VolcanoIcon className={style.alertIcon}/> || ""}
                                    {item.type === "DR" && <AirIcon className={style.alertIcon}/> || ""}
                                    {item.type === "WF" && <WhatshotIcon className={style.alertIcon}/> || ""}
                                    <span className={style[item?.alertLevel]}>{item?.properties?.name}</span>
                                    <span>|</span>
                                    <span>{moment(item?.properties?.fromdate).format("YYYY-MM-DD HH:mm:ss")}</span>
                                </div>
                            )
                        )}
                    </Scrollbars>
                </div>
            </div>

            <div className={[style.alertRow].join(" ")} ref={alertRef}>
                <div
                    className={style.header}
                    onClick={() => handlerShowHeader("filter")}
                >
                    {/* <img src={warningAlert} alt=""/> */}
                    <span>Filter</span>
                </div>

                <div className={[style.alertList, activeHeader === "filter" ? style.active : ""].join(" ")}>
                    <Scrollbars style={{height: "250px"}}>
                        <div>
                            <div>
                                <label>Filter by Date</label>
                                <div className={[style.checkboxGroup, style.dateGroup].join(" ")}>
                                    <Input class={style.inputDate} type="date" id="dateFrom"  title="From" value={filterDate[0]} handleChange={(e) => handlerFilterDate(e.target.value, 0)}/>
                                    <Input class={style.inputDate} type="date" id="dateTo" title="To" value={filterDate[1]} handleChange={(e) => handlerFilterDate(e.target.value, 1)}/>
                                </div>
                            </div>
                            <div>
                                <label>Filter by type</label>
                                <div className={style.checkboxGroup}>
                                    <Checkbox name="Earthquakes" id="Earthquakes" className={style.checkbox} label="Earthquakes" onChange={() => handlerFilterType("EQ")} checked={filterType.includes("EQ")}/>
                                    <Checkbox name="Tsunamis" id="Tsunamis" className={style.checkbox} label="Tsunamis" onChange={() => handlerFilterType("TS")} checked={filterType.includes("TS")}/>
                                    <Checkbox name="Floods" id="Floods" className={style.checkbox} label="Floods" onChange={() => handlerFilterType("FL")} checked={filterType.includes("FL")}/>
                                    <Checkbox name="Cyclones" id="Cyclones" className={style.checkbox} label="Cyclones" onChange={() => handlerFilterType("TC")} checked={filterType.includes("TC")}/>
                                    <Checkbox name="Volcanoes" id="Volcanoes" className={style.checkbox} label="Volcanoes" onChange={() => handlerFilterType("VO")} checked={filterType.includes("VO")}/>
                                    <Checkbox name="Droughts" id="Droughts" className={style.checkbox} label="Droughts" onChange={() => handlerFilterType("DR")} checked={filterType.includes("DR")}/>
                                    <Checkbox name="Forest Fires" id="Forest Fires" className={style.checkbox} label="Forest Fires" onChange={() => handlerFilterType("WF")} checked={filterType.includes("WF")}/>
                                </div>

                            </div>
                            <div>
                                <label>Filter by level</label>
                                <div className={style.checkboxGroup}>
                                    <Checkbox name="Red" id="Red" className={style.checkbox} label="Red" onChange={() => handlerFilterLevel("red")} checked={filterLevel.includes("red")}/>
                                    <Checkbox name="Orange" id="Orange" className={style.checkbox} label="Orange" onChange={() => handlerFilterLevel("orange")} checked={filterLevel.includes("orange")}/>
                                    <Checkbox name="Green" id="Green" className={style.checkbox} label="Green" onChange={() => handlerFilterLevel("Green")} checked={filterLevel.includes("Green")}/>
                                </div>
                            </div>
                            <div>
                                <Button class={style.button} title="Search" handleClick={() => handlerApplyFilter()}/>
                            </div>
                        </div>
                    </Scrollbars>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => ({
    data: state.page.data
});

const mapDispatchToProps = dispatch => ({
    showHideAlerts: data => dispatch(showHideAlerts(data)),
    hideAlerts: data => dispatch(hideAlerts(data)),
    setCurrentItem: data => dispatch(setCurrentItem(data)),
    getLogs: data => dispatch(getLogs(data)),
    getGdacs: data => dispatch(getGdacs(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ListGdacs);
